import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { CodexLibModule, LayoutService } from 'codex-lib';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpInterceptorService } from 'src/app/services/http-interceptor.service';
import { ConfirmModalComponent } from 'src/app/shared-components/confirm-modal/confirm-modal.component';
import { AlertModalComponent } from 'src/app/envelope/signatory-add/alert-modal/alert-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskModule } from 'ngx-mask';
import { NgxLoadingModule } from 'ngx-loading';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { SingleLetterUpper } from './pipe/single-letter-upper.pipe';
import { BryExtensionComponent } from '../bry/bry-extension/bry-extension.component';
import { AlertModalOkComponent } from 'src/app/shared-components/alert-modal-ok/alert-modal-ok.component';
import { GenericGridComponent } from 'src/app/shared-components/generic-grid/generic-grid.component';
import { CustomTranslateModule } from 'src/app/translate/custom-translate.module';
import { ConfirmRadioComponent } from 'src/app/shared-components/confirm-radio/confirm-radio.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DropdownLanguageComponent } from '../../shared-components/dropdown-language/dropdown-language.component';
import { DatetimeFormatLanguage } from './pipe/datetime-format-language.pipe';
import { CodexNotificationService } from 'src/app/services/codex-notification.service';
import { IntlTelInputComponent } from 'src/app/shared-components/intl-tel-input/intl-tel-input.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { PhoneObfuscatePipe } from 'src/app/core/pipe/phone-obfuscate.pipe';
import { OnecasePipe } from 'src/app/core/pipe/one-case.pipe';
import { MailObfuscatePipe } from 'src/app/core/pipe/mail-obfuscate.pipe';
import { PreventDoubleclickDirective } from './directives/prevent-doubleclick.directive';
import { ContactFormComponent } from '../../shared-components/contact-form/contact-form.component';
import { ParticipantModalComponent } from 'src/app/shared-components/participant-modal/participant-modal.component';
import { TableHeaderButtonsComponent } from 'src/app/envelope/signatory-add/table-header-buttons/table-header-buttons.component';
import { SignatoryTableComponent } from 'src/app/envelope/signatory-table/signatory-table.component';
import { AuthorizerTableComponent } from 'src/app/envelope/envelope-authorizer/authorizer-table/authorizer-table.component';
import { ObserverTableComponent } from 'src/app/envelope/envelope-observer/observer-table/observer-table.component';
import { ContactTableComponent } from '../../shared-components/contact-table/contact-table.component';
import { SignatureListModalComponent } from '../verification/pages/signature-list-modal/signature-list-modal.component';

@NgModule({
  declarations: [
    ConfirmModalComponent,
    ConfirmRadioComponent,
    AlertModalOkComponent,
    AlertModalComponent,
    SingleLetterUpper,
    BryExtensionComponent,
    GenericGridComponent,
    ConfirmRadioComponent,
    DropdownLanguageComponent,
    DatetimeFormatLanguage,
    IntlTelInputComponent,
    PhoneObfuscatePipe,
    OnecasePipe,
    MailObfuscatePipe,
    PreventDoubleclickDirective,
    ContactFormComponent,
    ContactTableComponent,
    ParticipantModalComponent,
    SignatoryTableComponent,
    TableHeaderButtonsComponent,
    AuthorizerTableComponent,
    ObserverTableComponent,
    SignatureListModalComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    NgbModule,
    HttpClientModule,
    CodexLibModule.forRoot({
      notificationService: CodexNotificationService,
    }),
    NgxMaskModule.forRoot(),
    NgxLoadingModule.forRoot({}),
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    CustomTranslateModule,
    PdfViewerModule,
    NgxExtendedPdfViewerModule,
    InfiniteScrollModule,
    NgxIntlTelInputModule,
  ],
  providers: [
    LayoutService,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
  ],
  exports: [
    ConfirmModalComponent,
    ConfirmRadioComponent,
    AlertModalComponent,
    AlertModalOkComponent,
    FormsModule,
    ReactiveFormsModule,
    CodexLibModule,
    FontAwesomeModule,
    NgbModule,
    AlertModalComponent,
    TranslateModule,
    HttpClientModule,
    NgxMaskModule,
    NgxLoadingModule,
    SingleLetterUpper,
    BryExtensionComponent,
    GenericGridComponent,
    CustomTranslateModule,
    ConfirmRadioComponent,
    PdfViewerModule,
    NgxExtendedPdfViewerModule,
    InfiniteScrollModule,
    DropdownLanguageComponent,
    DatetimeFormatLanguage,
    IntlTelInputComponent,
    PhoneObfuscatePipe,
    OnecasePipe,
    MailObfuscatePipe,
    PreventDoubleclickDirective,
    ContactFormComponent,
    ParticipantModalComponent,
    ContactTableComponent,
    SignatureListModalComponent
  ],
})
export class SharedModule {}
